export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  imageSeq: string;
}

export const categories: Category[] = [
  {
    slug: 'shengli-yuanli',
    name: '生理原理',
    description: '从解剖学和生理学角度深入理解高潮喷水的科学机制',
    icon: 'ri-microscope-line',
    imageSeq: 'cat-physiology',
  },
  {
    slug: 'jiqiao-fangfa',
    name: '技巧方法',
    description: '基于科学理论的安全、有效的实践技巧与方法指导',
    icon: 'ri-heart-pulse-line',
    imageSeq: 'cat-techniques',
  },
  {
    slug: 'jiankang-zhishi',
    name: '健康知识',
    description: '全面的性健康知识，帮助你建立正确的身体认知',
    icon: 'ri-mental-health-line',
    imageSeq: 'cat-health',
  },
  {
    slug: 'changjian-wuqu',
    name: '常见误区',
    description: '破除流传已久的迷思，用科学证据还原事实真相',
    icon: 'ri-lightbulb-flash-line',
    imageSeq: 'cat-myths',
  },
];